!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("styled-components"), require("@tinacms/react-modals"), require("@tinacms/form-builder"), require("@tinacms/forms"), require("@tinacms/icons"), require("@tinacms/styles"), require("react-dismissible"), require("@tinacms/react-core")) : "function" == typeof define && define.amd ? define(["exports", "react", "styled-components", "@tinacms/react-modals", "@tinacms/form-builder", "@tinacms/forms", "@tinacms/icons", "@tinacms/styles", "react-dismissible", "@tinacms/react-core"], e) : e((n = n || self)["@tinacms/react-forms"] = {}, n.React, n.styled, n.reactModals, n.formBuilder, n.forms, n.icons, n.styles, n.reactDismissible, n.reactCore);
}(this, function (n, l, e, o, a, s, c, u, d, f) {
  "use strict";

  var t = "default" in e ? e.default : e;

  function m(t, r) {
    var i,
        o,
        a,
        n,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      throw: e(1),
      return: e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (i) throw new TypeError("Generator is already executing.");

          for (; l;) {
            try {
              if (i = 1, o && (a = 2 & e[0] ? o.return : e[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, e[1])).done) return a;

              switch (o = 0, a && (e = [2 & e[0], a.value]), e[0]) {
                case 0:
                case 1:
                  a = e;
                  break;

                case 4:
                  return l.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  l.label++, o = e[1], e = [0];
                  continue;

                case 7:
                  e = l.ops.pop(), l.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = l.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    l = 0;
                    continue;
                  }

                  if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                    l.label = e[1];
                    break;
                  }

                  if (6 === e[0] && l.label < a[1]) {
                    l.label = a[1], a = e;
                    break;
                  }

                  if (a && l.label < a[2]) {
                    l.label = a[2], l.ops.push(e);
                    break;
                  }

                  a[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }

              e = r.call(t, l);
            } catch (n) {
              e = [6, n], o = 0;
            } finally {
              i = a = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function r(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var i,
      p,
      g,
      h,
      b,
      y,
      v,
      w,
      x,
      C = function C(n) {
    var e = n.plugin,
        t = n.onClick,
        r = l.useState(!1),
        i = r[0],
        o = r[1];
    return l.createElement(l.Fragment, null, l.createElement(z, {
      onClick: function onClick() {
        o(function (n) {
          return !n;
        }), t();
      }
    }, e.name), i && l.createElement(k, {
      plugin: e,
      close: function close() {
        return o(!1);
      }
    }));
  },
      k = function k(n) {
    var t = n.plugin,
        r = n.close,
        i = f.useCMS(),
        e = l.useMemo(function () {
      return new s.Form({
        id: "create-form-id",
        label: "create-form",
        fields: t.fields,
        actions: t.actions,
        buttons: t.buttons,
        initialValues: t.initialValues || {},
        reset: t.reset,
        onChange: t.onChange,
        onSubmit: function onSubmit(e) {
          return function (o, a, l, s) {
            return new (l = l || Promise)(function (n, e) {
              function t(n) {
                try {
                  i(s.next(n));
                } catch (n) {
                  e(n);
                }
              }

              function r(n) {
                try {
                  i(s.throw(n));
                } catch (n) {
                  e(n);
                }
              }

              function i(e) {
                e.done ? n(e.value) : new l(function (n) {
                  n(e.value);
                }).then(t, r);
              }

              i((s = s.apply(o, a || [])).next());
            });
          }(void 0, void 0, void 0, function () {
            return m(this, function (n) {
              switch (n.label) {
                case 0:
                  return [4, t.onSubmit(e, i).then(function () {
                    r();
                  })];

                case 1:
                  return n.sent(), [2];
              }
            });
          });
        }
      });
    }, [r, i, t]);
    return l.createElement(o.Modal, null, l.createElement(o.ModalPopup, null, l.createElement(o.ModalHeader, {
      close: r
    }, t.name), l.createElement(o.ModalBody, null, l.createElement(a.FormBuilder, {
      form: e
    }))));
  },
      E = t.div.withConfig({
    displayName: "ContentMenuWrapper",
    componentId: "sc-p2g1bc"
  })(i = i || r(["\n  position: relative;\n  grid-area: actions;\n  justify-self: end;\n"], ["\n  position: relative;\n  grid-area: actions;\n  justify-self: end;\n"])),
      M = t(u.Button).withConfig({
    displayName: "CreateToggleButton",
    componentId: "sc-yf3ogn"
  })(g = g || r(["\n  display: flex;\n  align-items: center;\n  transition: all 150ms ease-out;\n  padding: 0 10px;\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n  }\n  &:focus {\n    outline: none !important;\n  }\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2em;\n    height: 2em;\n    margin-right: 0.25rem;\n    transform-origin: 50% 50%;\n    transition: all 150ms ease-out;\n  }\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  transition: all 150ms ease-out;\n  padding: 0 10px;\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n  }\n  &:focus {\n    outline: none !important;\n  }\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2em;\n    height: 2em;\n    margin-right: 0.25rem;\n    transform-origin: 50% 50%;\n    transition: all 150ms ease-out;\n  }\n  ", ";\n"]), function (n) {
    return n.open && e.css(p = p || r(["\n      background-color: transparent;\n      svg {\n        transform: rotate(45deg);\n      }\n    "], ["\n      background-color: transparent;\n      svg {\n        transform: rotate(45deg);\n      }\n    "]));
  }),
      q = t.div.withConfig({
    displayName: "ContentMenu",
    componentId: "sc-rz3rur"
  })(v = v || r(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", "\n  ", "\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", "\n  ", "\n  ", ";\n"]), function (n) {
    return "left" === n.direction && e.css(h = h || r(["\n      right: 0;\n      transform-origin: 100% 0;\n    "], ["\n      right: 0;\n      transform-origin: 100% 0;\n    "]));
  }, function (n) {
    return "right" === n.direction && e.css(b = b || r(["\n      left: 0;\n      transform-origin: 0 0;\n    "], ["\n      left: 0;\n      transform-origin: 0 0;\n    "]));
  }, function (n) {
    return n.open && e.css(y = y || r(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      z = t.button.withConfig({
    displayName: "CreateButton",
    componentId: "sc-h0iaw5"
  })(w = w || r(["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 40px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 40px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"])),
      S = t.span.withConfig({
    displayName: "DesktopLabel",
    componentId: "sc-mymda6"
  })(x = x || r(["\n  display: none;\n  @media (min-width: 1030px) {\n    display: inline;\n  }\n"], ["\n  display: none;\n  @media (min-width: 1030px) {\n    display: inline;\n  }\n"]));

  n.CreateContentMenu = function (n) {
    var e = n.sidebar,
        t = f.useCMS(),
        r = l.useState(!1),
        i = r[0],
        o = r[1],
        a = t.plugins.findOrCreateMap("content-creator");
    return f.useSubscribable(a), a.all().length ? l.createElement(E, null, e ? l.createElement(u.IconButton, {
      onClick: function onClick() {
        return o(!0);
      },
      open: i,
      primary: !0
    }, l.createElement(c.AddIcon, null)) : l.createElement(M, {
      onClick: function onClick() {
        return o(!0);
      },
      open: i
    }, l.createElement(c.AddIcon, null), " ", l.createElement(S, null, "New")), l.createElement(q, {
      open: i,
      direction: e ? "left" : "right"
    }, l.createElement(d.Dismissible, {
      click: !0,
      escape: !0,
      onDismiss: function onDismiss() {
        return o(!1);
      },
      disabled: !i
    }, a.all().map(function (n) {
      return l.createElement(C, {
        plugin: n,
        key: n.name,
        onClick: function onClick() {
          o(!1);
        }
      });
    })))) : null;
  }, n.DesktopLabel = S, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});